import {
    HTTP_STATUS_CODES,
    HTTP_BAD_REQUEST,
    HTTP_NOT_FOUND,
    HTTP_INTERNAL_SERVER_ERROR,
} from "../../constants/http";

const parseStatusCodeFromGqlError = (gqlError = {}) => {
    let code = HTTP_INTERNAL_SERVER_ERROR;
    if (/HTTP 404/.test(gqlError.message)) {
        code = HTTP_NOT_FOUND;
    } else if (gqlError.extensions?.code === "BAD_REQUEST") {
        code = HTTP_BAD_REQUEST;
    }
    return code;
};

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
export class HttpError extends Error {
    constructor(code, message) {
        if (!message) {
            message = HTTP_STATUS_CODES[code] || "";
        }
        super(message);
        this.name = "HttpError";
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HttpError);
        }
        this.code = code;
    }
}

export class GqlError extends Error {
    constructor(errors) {
        const error = typeof errors?.[0] === "object" ? errors?.[0] : {};
        const code = parseStatusCodeFromGqlError(error);
        const message = HTTP_STATUS_CODES[code] || "";
        super(message);
        this.name = "GqlError";
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, GqlError);
        }
        this.code = code;
        this.extraData = errors;
    }
}
